var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Link } from "react-router-dom";
import { parseISO, format } from "date-fns";
import { DragDropContext, Draggable, Droppable, } from "react-beautiful-dnd";
import { Box, IconButton, Menu, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from "@material-ui/core";
import { MoreVert } from "@material-ui/icons";
import { DragIndicator } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { blue, grey, purple, green, red } from "@material-ui/core/colors";
import { useConfirmationDialog } from "frontend/src/ui/dialog";
import { paths } from "frontend/src/pages/paths/index";
import { useCopyPlaylist, 
// useDeletePlaylist,
usePublishPlaylist, } from "frontend/src/domain/playlists";
var useStyles = makeStyles({
    remove: {
        color: red[700],
    },
    published: {
        color: function (_a) {
            var isPublished = _a.isPublished;
            return (isPublished ? green[500] : red[700]);
        },
    },
    dragHandleIcon: {
        fill: grey[500],
    },
    tr: {
        background: "white",
        "& td:nth-of-type(1), td:nth-of-type(2), td:nth-of-type(7)": {
            width: "5%",
        },
        "& td:nth-of-type(3), td:nth-of-type(4), td:nth-of-type(5)": {
            width: "25%",
        },
        "& td:nth-of-type(6)": {
            width: "10%",
        },
        "&.Mui-selected, &.Mui-selected:hover": {
            background: blue[50],
        },
        "&[data-is-dragging='true']": {
            background: purple[50],
        },
    },
});
export var ReorderPlaylistsTable = React.memo(function (_a) {
    // const playerPlaylistId = usePlayerPlaylistId();
    // const audio = useAudio();
    var canReorder = _a.canReorder, entries = _a.entries, onPlaylistMove = _a.onPlaylistMove, onPlaylistRemove = _a.onPlaylistRemove;
    var onDragEnd = function (result) {
        var _a;
        if (typeof ((_a = result === null || result === void 0 ? void 0 : result.destination) === null || _a === void 0 ? void 0 : _a.index) === "number") {
            onPlaylistMove(result.source.index, result.destination.index);
        }
    };
    return (React.createElement(DragDropContext, { onDragEnd: onDragEnd },
        React.createElement(Droppable, { droppableId: "droppable" }, function (provided) { return (React.createElement(TableContainer, { component: Paper },
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        canReorder ? React.createElement(TableCell, null, null) : '',
                        React.createElement(TableCell, null, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                        React.createElement(TableCell, null, "\u0422\u0438\u043F"),
                        React.createElement(TableCell, null, "\u0412\u0440\u0435\u043C\u044F"),
                        React.createElement(TableCell, null, "\u041A\u043E\u043B-\u0432\u043E \u0442\u0440\u0435\u043A\u043E\u0432"),
                        React.createElement(TableCell, null, "\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D"),
                        React.createElement(TableCell, null, "\u0421\u043E\u0437\u0434\u0430\u043D"),
                        React.createElement(TableCell, null, "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D"),
                        React.createElement(TableCell, null, null))),
                React.createElement(TableBody, __assign({}, provided.droppableProps, { ref: provided.innerRef }),
                    canReorder
                        ? entries.map(function (_a, index) {
                            var id = _a.id, playlist = _a.playlist;
                            return (React.createElement(Draggable, { key: id, draggableId: id, index: index }, function (provided, snapshot) {
                                var loading = false;
                                return (React.createElement(Row, { index: index, loading: loading, provided: provided, snapshot: snapshot, playlist: playlist, onRemove: onPlaylistRemove, canReorder: true }));
                            }));
                        }) : entries.map(function (_a, index) {
                        var id = _a.id, playlist = _a.playlist;
                        var loading = false;
                        // XXX
                        var provided = {
                            draggableProps: { 'data-rbd-draggable-context-id': '', 'data-rbd-draggable-id': '' },
                            innerRef: function (_) { return null; }
                        };
                        // XXX
                        var snapshot = { isDragging: false, isDropAnimating: false };
                        return (React.createElement(Row, { index: index, loading: loading, provided: provided, snapshot: snapshot, playlist: playlist, onRemove: onPlaylistRemove, canReorder: false }));
                    }),
                    provided.placeholder)))); })));
});
var Row = React.memo(function (_a) {
    var index = _a.index, loading = _a.loading, snapshot = _a.snapshot, provided = _a.provided, _b = _a.playlist, title = _b.title, playlist = __rest(_b, ["title"]), onRemove = _a.onRemove, canReorder = _a.canReorder;
    var remove = function () { return onRemove(index); };
    var type = playlist.type === "public"
        ? "Публичный"
        : "Пользовательский";
    var id = playlist.id;
    var isPublished = playlist.isPublished;
    var trackCount = playlist.trackCount;
    var duration = playlist.duration.formatted;
    var classes = useStyles({ isPublished: playlist.isPublished });
    var _c = __read(React.useState(null), 2), anchor = _c[0], setAnchor = _c[1];
    var handleClick = function (event) {
        setAnchor(event.currentTarget);
    };
    var close = function () { return setAnchor(null); };
    // const remove = useDeletePlaylist();
    var copy = useCopyPlaylist();
    var publish = usePublishPlaylist().mutate;
    var _d = useConfirmationDialog({
        message: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442 \"".concat(title, "\"?"),
        // onConfirm: () => remove.do(id),
        onConfirm: function () { return onRemove(index); },
        open: false,
    }), open = _d.open, Dialog = _d.Dialog;
    return (React.createElement(TableRow, __assign({ className: classes.tr, innerRef: provided.innerRef, "data-is-dragging": snapshot.isDragging }, provided.draggableProps),
        canReorder
            ? (React.createElement(TableCell, __assign({}, provided.dragHandleProps),
                React.createElement(Box, { display: "flex", alignItems: "center" },
                    React.createElement(DragIndicator, { fontSize: "small", className: classes.dragHandleIcon })))) : '',
        React.createElement(TableCell, null, title),
        React.createElement(TableCell, null, type),
        React.createElement(TableCell, null, duration),
        React.createElement(TableCell, null, trackCount),
        React.createElement(TableCell, { className: classes.published }, playlist.isPublished ? 'Да' : 'Нет'),
        React.createElement(TableCell, null, format(parseISO(playlist.createdAt), "dd-MM-yyyy")),
        React.createElement(TableCell, null, format(parseISO(playlist.updatedAt), "dd-MM-yyyy")),
        React.createElement(TableCell, null,
            React.createElement(IconButton, { size: "small", onClick: handleClick },
                React.createElement(MoreVert, null)),
            React.createElement(Menu, { anchorEl: anchor, keepMounted: true, open: Boolean(anchor), onClose: close },
                React.createElement(MenuItem, { onClick: function () {
                        publish({ id: id, publish: !isPublished });
                        close();
                    } }, isPublished ? "Убрать из публикации" : "Опубликовать"),
                React.createElement(MenuItem, { component: Link, to: paths.admin.playlists.edit(id) }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C"),
                React.createElement(MenuItem, { onClick: function () {
                        copy.do(id);
                        close();
                    } }, "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C"),
                React.createElement(MenuItem, { className: classes.remove, onClick: function () {
                        onRemove(id);
                        close();
                    } }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C")))));
});
